import { create } from "zustand";

/**
 * Bridges "Upgrade to Plus" affordances scattered across the app to the
 * dedicated pricing route. A caller flags a request and navigates to Profile;
 * the Profile screen consumes the flag and forwards the user to /pricing.
 */
type UpgradeState = {
  /** Set when something asked to open the upgrade/plan modal. */
  requested: boolean;
  request: () => void;
  consume: () => void;
};

export const useUpgradeStore = create<UpgradeState>((set) => ({
  requested: false,
  request: () => set({ requested: true }),
  consume: () => set({ requested: false }),
}));
